function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Location from './../utils/model';
import defaultPropTypes from './../utils/prop-types';
import { renderComponents } from './../utils/convenience';
import FilterList from './../views/filter-list';
import LocationDetail from './../views/location-detail';
import LocationSortingManager from './../utils/LocationSortingManager';
import ListItem from './lists/list-items/list-item';
import { uniqueId } from 'underscore';
import { trackHCLClinicPhone } from '../../../../../js/project/tracking-gtm-ga4';
var ClosestCounter = /*#__PURE__*/function (_React$Component) {
  function ClosestCounter(props) {
    var _this;
    _classCallCheck(this, ClosestCounter);
    _this = _callSuper(this, ClosestCounter, [props]);
    _this.state = {
      clinicCounter: 0
    };
    return _this;
  }
  _inherits(ClosestCounter, _React$Component);
  return _createClass(ClosestCounter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.locations !== prevProps.locations) {
        this.setClinicCounter(this.clinicCounterFunction());
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setClinicCounter(this.clinicCounterFunction());
    }
  }, {
    key: "clinicCounterFunction",
    value: function clinicCounterFunction() {
      var _this2 = this;
      var clinicCounter = 0;
      this.props.locations.map(function (location) {
        if (parseFloat(location.Distance) <= parseFloat(_this2.props.text.dictionary.counterRange)) {
          clinicCounter++;
        }
      });
      return clinicCounter;
    }
  }, {
    key: "setClinicCounter",
    value: function setClinicCounter(clinicCounter) {
      this.setState({
        clinicCounter: clinicCounter
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("h3", {
        className: "closest-markers"
      }, this.state.clinicCounter, " ", this.props.text.dictionary.clinics, " ", this.props.text.dictionary.within, " ", this.props.text.dictionary.counterRange, " ", this.props.text.Unit, " ");
    }
  }]);
}(React.Component);
var ScrolledList = /*#__PURE__*/function (_React$Component2) {
  function ScrolledList(props) {
    var _this3;
    _classCallCheck(this, ScrolledList);
    _this3 = _callSuper(this, ScrolledList, [props]);
    _this3.state = {
      mapLoading: false,
      distances: {},
      showTyp: false,
      typHtml: null
    };
    _this3.handleSelectLocationClick = _this3.handleSelectLocationClick.bind(_this3);
    _this3.selectedLocation = new Location();
    _this3.isLocallySelected = false;
    _this3.locationsListRef = /*#__PURE__*/React.createRef();
    return _this3;
  }
  _inherits(ScrolledList, _React$Component2);
  return _createClass(ScrolledList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      if (window.location.href.indexOf('typ=hcl') > -1) {
        setTimeout(function () {
          _this4.setState({
            showTyp: true,
            typHtml: document.querySelector('.location-form-submit-success').outerHTML || null
          });
          var listContainer = document.querySelector('.locations-spot.component');
          window.scrollTo({
            top: listContainer.offsetTop || 0,
            behavior: 'smooth'
          });
        }, 1000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.userLocation.Latitude !== this.props.userLocation.Latitude && prevProps.userLocation.Longitude !== this.props.userLocation.Longitude || !prevProps.locations.length && this.props.locations.length) {
        this.setDistances(this.distanceFunction());
      }
    }
  }, {
    key: "distanceFunction",
    value: function distanceFunction() {
      var _this5 = this;
      var newDistances = {};
      this.props.locations.map(function (location) {
        var distanceLength = LocationSortingManager.getDistanceFromLatLngInKm(_this5.props.userLocation, location);
        distanceLength = _this5.props.settings.Unit === 'Miles' ? distanceLength * 0.621371 : distanceLength;
        newDistances[location.UniqueId] = distanceLength.toFixed(0);
      });
      return newDistances;
    }
  }, {
    key: "setDistances",
    value: function setDistances(distances) {
      this.setState({
        distances: distances
      });
    }
  }, {
    key: "scrollSelectedIntoView",
    value: function scrollSelectedIntoView() {
      var selectedItemParent = document.querySelector('.locations-list > .content');
      var selectedItemTopPos = document.querySelector('.locations-list > .content .selected').offsetTop;
      selectedItemParent.scrollTo({
        top: selectedItemTopPos,
        behavior: 'smooth'
      });
    }
  }, {
    key: "handleSelectLocationClick",
    value: function handleSelectLocationClick(location) {
      this.setState({
        showTyp: false
      });
      this.isLocallySelected = true;
      this.props.onSelectLocation(location);
    }
  }, {
    key: "handlePhoneClick",
    value: function handlePhoneClick(location) {
      window.DGS.Event.getInstance().trigger('trackLocationsPhoneNumberList', location.Name, location.PostalCode);
      trackHCLClinicPhone("".concat(location.Name, " - ").concat(location.PostalCode));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var ItemView = this.props.listItemView;
      var DetailView = this.props.listDetailView;
      if (!this.selectedLocation.equals(this.props.selectedLocation) && !this.props.selectedLocation.isDefault()) {
        this.selectedLocation = this.props.selectedLocation;
        this.isNewlySelected = true;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-list ".concat(this.props.layoutType),
        ref: this.locationsListRef
      }, /*#__PURE__*/React.createElement(Route, {
        path: "/location/:id",
        render: function render(props) {
          var dist = 0;
          var locationForId = _this6.props.locations.find(function (loc) {
            return loc.UniqueId === props.match.params.id;
          });
          if (locationForId) dist = _this6.state.distances[locationForId.UniqueId];
          return /*#__PURE__*/React.createElement(DetailView, _extends({}, props, _this6.props, {
            distance: dist
          }));
        }
      }), this.props.filterListOpen && /*#__PURE__*/React.createElement(FilterList, this.props), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/",
        render: function render() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, renderComponents('header', _this6.props.header, _this6.props), /*#__PURE__*/React.createElement("div", {
            className: "content"
          }, _this6.state.showTyp && _this6.state.typHtml && /*#__PURE__*/React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: _this6.state.typHtml
            }
          }), _this6.props.locations.length > 0 && /*#__PURE__*/React.createElement(ClosestCounter, {
            locations: _this6.props.locations,
            text: _this6.props.settings,
            searchValue: _this6.props.userLocation.Name
          }), _this6.props.locations.slice(0, 30).map(function (location, index) {
            var itemProps = Object.assign({
              key: "locationItem-".concat(location.UniqueId),
              location: location,
              index: index,
              distance: _this6.state.distances[location.UniqueId] || '',
              locationsListRef: _this6.locationsListRef
            }, _this6.props, {
              onSelectLocation: _this6.handleSelectLocationClick,
              onPhoneClick: _this6.handlePhoneClick
            });
            if (_this6.isNewlySelected && location.equals(_this6.props.selectedLocation)) {
              _this6.isNewlySelected = false;
              if (!_this6.isLocallySelected) {
                setTimeout(_this6.scrollSelectedIntoView, 0);
              }
              _this6.isLocallySelected = false;
            }
            return /*#__PURE__*/React.createElement(ItemView, itemProps);
          })), renderComponents('footer', _this6.props.footer, _this6.props));
        }
      }));
    }
  }]);
}(React.Component);
export default ScrolledList;
ScrolledList.propTypes = {
  selectedLocation: defaultPropTypes.location,
  userLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  locations: defaultPropTypes.locations,
  onSelectLocation: defaultPropTypes.func,
  onOpenLocation: defaultPropTypes.func,
  onCloseLocation: defaultPropTypes.func,
  onCloseFilterList: defaultPropTypes.func,
  onChangeFilter: defaultPropTypes.func,
  layoutType: defaultPropTypes.layoutType,
  settings: defaultPropTypes.settings,
  header: PropTypes.arrayOf(PropTypes.element),
  footer: PropTypes.arrayOf(PropTypes.element),
  listItemView: PropTypes.func,
  listDetailView: PropTypes.func,
  filterListOpen: PropTypes.bool,
  locationDetailOpen: PropTypes.bool,
  locationsStateChanged: PropTypes.string
};
ScrolledList.defaultProps = {
  selectedLocation: defaultPropTypes.defaultLocation(),
  userLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  locations: defaultPropTypes.defaultLocations,
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onOpenLocation: defaultPropTypes.defaultOnOpenLocation,
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  onCloseFilterList: defaultPropTypes.defaultOnCloseFilterList,
  onChangeFilter: defaultPropTypes.defaultOnChangeFilter,
  layoutType: defaultPropTypes.defaultLayoutType,
  settings: defaultPropTypes.defaultSettings,
  header: [],
  footer: [],
  listItemView: ListItem,
  listDetailView: LocationDetail,
  filterListOpen: false,
  locationDetailOpen: false,
  locationsStateChanged: ''
};